import {combineReducers, Reducer} from "redux";
import { PackagesState } from "@models/package";
import { PackagesActionTypes } from "@actions/package";

export const initialState: PackagesState = {
  data: [],
};

const data = (state = initialState.data, action) => {
  switch (action.type) {
    case PackagesActionTypes.FETCH_SUCCESS: {
      return action.payload
    }
    
    default:
      return state
  }
};


const reducer: Reducer<PackagesState> = combineReducers({
  data,
});

export {reducer as packageReducer}
